import { GlButton, GlDisclosureDropdown, GlDisclosureDropdownGroup, GlDisclosureDropdownItem } from '@gitlab/ui';
import { __, s__ } from '~/locale';
import { PROMO_URL } from '~/constants';
import { exploreRootPath } from '~/lib/utils/path_helpers/explore';
import { newUserRegistrationPath, newUserSessionPath } from '~/lib/utils/path_helpers/routes';
export default {
    name: 'PromoMenu',
    components: {
        GlButton,
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup,
        GlDisclosureDropdownItem
    },
    inject: [
        'isSaas'
    ],
    props: {
        sidebarData: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        pricingUrl: {
            type: String,
            required: true
        },
        allowSignUp: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        exploreItem () {
            return {
                text: __('Explore'),
                href: exploreRootPath({
                    organizationPath: null
                })
            };
        },
        items () {
            if (!this.isSaas) {
                return [
                    {
                        ...this.exploreItem
                    }
                ];
            }
            return [
                {
                    text: s__('LoggedOutMarketingHeader|Why GitLab'),
                    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- promo/marketing site path used with PROMO_URL (about.gitlab.com)
                    href: this.promoUrl('/why-gitlab')
                },
                {
                    text: s__('LoggedOutMarketingHeader|Pricing'),
                    href: this.pricingUrl
                },
                {
                    text: s__('LoggedOutMarketingHeader|Contact Sales'),
                    // eslint-disable-next-line @gitlab/no-hardcoded-urls -- promo/marketing site path used with PROMO_URL (about.gitlab.com)
                    href: this.promoUrl('/sales'),
                    extraAttrs: {
                        dataMenuOnly: true
                    }
                },
                {
                    ...this.exploreItem
                }
            ];
        },
        visibleItems () {
            return this.items.filter((item)=>!item.extraAttrs?.dataMenuOnly);
        }
    },
    methods: {
        newUserRegistrationPath () {
            return newUserRegistrationPath({
                organizationPath: null
            });
        },
        signInPath () {
            return newUserSessionPath({
                redirect_to_referer: 'yes',
                organizationPath: null
            });
        },
        promoUrl (url) {
            return `${PROMO_URL}${url}`;
        }
    }
};
